import React from "react";
import "../../Styles/footer.css";
import { FaFacebookF } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaLinkedinIn } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <>
      <section className="footer">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 footer-links">
              <h5>US Cities properties:</h5>
              <a href="#">Manhattan</a>
              <a href="#">Boston</a>
              <a href="#">Washington, D.C. </a>
              <a href="#">Chicago</a>
              <a href="#">Honolulu</a>
              <a href="#">San Francisco</a>
              <a href="#">Miami</a>
              <a href="#">Los Angeles</a>
              <a href="#">San Diego</a>
              <a href="#">Long Beach</a>
              <a href="#">Staten Island</a>
              <a href="#">Oakland</a>
              <a href="#">Seattle</a>
              <a href="#">Austin</a>
              <a href="#">San jose</a>
              <a href="#">Sacramento</a>
              <a href="#">Portland</a>
            </div>
            <div className="col-sm-12 footer-links">
              <h5>new properties:</h5>
              <a href="#">3 Bedrooms Apartment</a>
              <a href="#">Residential Apartment</a>
              <a href="#">Residential Villa</a>
              <a href="#">Residential Plots</a>
              <a href="#">Godrej Golf Villa </a>
              <a href="#">Pristine Golf Villas </a>
              <a href="#">Rise Resort Residences</a>
              <a href="#">Sunrise Sun Twilight</a>
              <a href="#">Ajnara London Square </a>
              <a href="#">Paramount Golf Foreste</a>
              <a href="#">Supertech Ritz Chateaux </a>
            </div>
            <div className="row footer-link-row">
              <div className="col-sm-12 col-lg-4 footer-logo">
                <a href="#">
                  {" "}
                  <img
                    className="img-fluid"
                    src="images\footer-logo.png"
                    alt="Logo"
                  />
                </a>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever.
                </p>
                <h6>Get Connected</h6>
                <div className="social-icon-footer">
                <div className="social-icon">
                <FaFacebookF/>
                </div>
                <div className="social-icon">
                <FaInstagram/>
                </div>
                <div className="social-icon">
                <FaXTwitter/>
                </div>
                <div className="social-icon">
                <FaLinkedinIn/>
                </div>
 
  
 
 
</div>

              </div>
              <div className="col-sm-0 col-lg-1 ">

              </div>
              <div className="col-sm-12 col-lg-3 quick-links">
                <h5>Quick Link</h5>
                <ul>
                <li onClick={() => navigate("/")}>Home</li>
                <li onClick={() => navigate("/about-us")}>About Us</li>
                <li onClick={() => navigate("/property-listing")}>Property</li>
                <li onClick={() => navigate("/blogs")}>Blogs</li>
                <li onClick={() => navigate("/contact-us")}>Contact Us</li>
              </ul>
              </div>
              <div className="col-sm-12 col-lg-4 newsletter">
                <h5>Newsletter</h5>
                <p>Subscribe To Our Latest newsletter to get news
                  about special discounts.</p>
                <div className="input-group">
                  <input
                    type="email"
                    className="form-control form-main"
                    placeholder="Enter your email"
                  />
                  <span className="input-group-btn">
                    <button className="submit-btn" type="submit">
                      Submit
                    </button>
                  </span>
                </div>

              </div>

            </div>
            <div className="row" >
              <div className="col-12 copyrite">
                <p>Copyright © 2024.  All rights reserved</p>
                <a href="/privacy-policy"><p>Privacy & Policy</p></a>
                <a href="/term-condition"><p>Terms & Condition</p></a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Footer;
